import BaseService from "../common/base.service";

class TodoService extends BaseService {
	constructor() {
		super('todos');
	}
}

export default new TodoService();